import axios from "axios";
import { baseURL } from "./eps";
import { getUserToken } from "../dataManager";
import { toast } from "sonner";

export const getUrl = (path) => baseURL + path;

export const getData = async (relativeUrl) => {
  const accessToken = await getUserToken();
  if (!accessToken) {
    throw new Error("User data or token not found");
  }

  const url = getUrl(relativeUrl);
  const options = {
    headers: {
      Authorization: accessToken,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.get(url, options);
    return response;
  } catch (err) {
    if (err.status === 403) {
      toast("Permission denied!", { duration: 2000 });
    }
    return err;
  }
};

export const getDataAnonimously = async (relativeUrl, data = {}) => {
  const url = getUrl(relativeUrl);
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.get(url, data, options);
    return response;
  } catch (err) {
    if (err.status === 403) {
      toast("Permission denied!", { duration: 2000 });
    }
    return err;
  }
};

export const postData = async (relativeUrl, data) => {
  const accessToken = await getUserToken();
  if (!accessToken) {
    throw new Error("User data or token not found");
  }
  const url = getUrl(relativeUrl);
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
  };
  try {
    const response = await axios.post(url, data, options);
    return response;
  } catch (err) {
    if (err.status === 403) {
      toast("Permission denied!", { duration: 2000 });
    }
    if (err?.response?.data) {
      // return null;
      return err;
    }
  }
};

export const postDataAnonimously = async (
  relativeUrl,
  data,
  moreHeaders = {}
) => {
  const url = getUrl(relativeUrl);
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...moreHeaders,
    },
  };
  try {
    const response = await axios.post(url, data, options);
    return response;
  } catch (err) {
    console.log("Error on Anonimously Post : ", err.code);
    if (err.code === "ERR_NETWORK") {
      toast.error(err.message, { duration: 2000 });
    } else if (err.status === 403) {
      toast.error("Permission denied!", { duration: 2000 });
    }
    return err;
  }
};

export const postFormData = async (relativeUrl, data) => {
  const accessToken = await getUserToken();
  if (!accessToken) {
    throw new Error("User data or token not found");
  }
  const url = getUrl(relativeUrl);
  try {
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: accessToken,
      },
    };
    const result = await axios.post(url, data, options);
    return result;
  } catch (error) {
    return null;
  }
};
